import Lenis from '@studio-freight/lenis'
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

//loading
import { headerBtn } from './module/common/headerBtn';

//anchor link
import { anchorLink } from './module/common/anchorLink';

const setScrollbarWidth = () => {
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
	// カスタムプロパティの値を更新する
	document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
};

setScrollbarWidth();

window.addEventListener("pageshow", function () {
	const lenis = new Lenis({
		lerp: 0.5, // 慣性の強さ
		duration: 1.7, // スクロールアニメーションの時間
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		smooth: true,
		smoothTouch: false,
	});

	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
	}

	requestAnimationFrame(raf);

	headerBtn();

});
window.addEventListener("resize", function () {
	setScrollbarWidth();
});
